import {
  maxDescription,
  maxEmail,
  maxName,
  maxSubject,
  minDescription,
  minName,
  minSubject,
} from "../Validators";
import { validations } from "./validations";

export const formRules = {
  first_name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(min, field),
    validations.max.text(max, field),
    validations.pattern.firstName,
  ],
  last_name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(min, field),
    validations.max.text(max, field),
    validations.pattern.lastName,
  ],
  name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(min, field),
    validations.max.text(max, field),
  ],
  phone: (field?: string) => [
    validations.required.text(field),
    validations.pattern.phone,
  ],
  email: (field?: string) => [
    validations.required.text(field),
    validations.email(field),
  ],
};

export const ContactRequest = (): any => ({
  full_name: (field?: string) => [
    validations.required.text(field),
    validations.min.text(minName, field),
    validations.max.text(maxName, field),
  ],
  email: (field?: string) => [
    validations.required.text(field),
    validations.email(field),
    validations.max.text(maxEmail, field),
  ],
  subject: (field?: string) => [
    validations.required.text(field),
    validations.min.text(minSubject, field),
    validations.max.text(maxSubject, field),
  ],
  message: (field?: string) => [
    validations.required.text(field),
    validations.min.text(minDescription, field),
    validations.max.text(maxDescription, field),
  ],
  re_captcha: (field?: string) => [
    validations.required.text(field),
    ({ getFieldValue }: any) => ({
      validator() {
        const captcha = getFieldValue("captcha");
        const recaptcha = getFieldValue("re_captcha");

        if (recaptcha) {
          if (captcha.trim() === recaptcha) {
            return Promise.resolve();
          } else {
            return Promise.reject("CAPTCHA does not match.");
          }
        }
        return Promise.resolve();
      },
    }),
  ],
});
